import styled from "styled-components";

export const StyledHeader = styled.header``;
